import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const API_URL = process.env.REACT_APP_API_URL
const auth = JSON.parse(localStorage.getItem("kt-auth-react-v"));

class ModalPersona extends Component {

  constructor(props) {
    super(props);
    if (props.action === "update")
      this.state = { data: [], show: false, id: props.item._id, alias: props.item.alias, insert: false };
    if (props.action === "insert")
      this.state = { data: [], show: false, insert: true };
    this.handleShow = this.handleShow.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  async onsubmit(e) {
    e.preventDefault();

    //console.log(this.props.parentData);

    let fetchUrl = `${API_URL}/persona/add`;
    if (!this.state.insert) {
      this.state.data.push({ 'key': 'alias', 'value': this.state.alias });
      this.state.data.push({ 'key': 'id', 'value': this.state.id });
      fetchUrl = `${API_URL}/persona/update`;
    }

    const formData = this.state.data;

    if (formData.length) {
      let formSerialized = {};

      formData.map(item => {
        Object.assign(formSerialized, { [item.key]: item.value });
        return item.value;
      });

      try {
        const response = await fetch(fetchUrl, {
          method: 'POST',
          body: JSON.stringify(formSerialized),
          headers: {
            'Content-Type': 'application/json',
            'auth-token': auth.api_token

          }
        });
        const jsonResponse = await response.json();
        if (response.status >= 200 && response.status < 300) {
          console.log(jsonResponse);
          this.props.refreshTable();
          this.setState({ data: [] });
          this.handleClose();
        }
        else {
          console.log(jsonResponse);
        }
      } catch (err) {
        console.log("se murio");
      }
    } else {
      this.handleClose();
    }
  }

  componentDidMount() {
    //if (!this.state.insert) {
      //let dataM = [];
      //dataM.push({ 'key': 'alias', 'value': this.state.alias });
      //dataM.push({ 'key': 'id', 'value': this.state.id });
      //this.setState({ data: dataM });
    //}
    this.setState({ show: false });
  }

  onChange(e) {
    const oldData = [...this.state.data];
    const newData = oldData.filter(item => item.key !== e.target.id);
    newData.push({ key: e.target.id, value: e.target.value });
    this.setState({ data: newData });
  }

  handleClose() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
    //show = id;
  }

  render() {

    var moment = require('moment');

    return (
      <>
        <Button variant="primary" onClick={() => { this.handleShow() }}>
          {this.props.children}
        </Button>

        <Modal show={this.state.show} onHide={() => { this.handleClose() }}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop="static"
        >
          <Form
            onSubmit={(e) => { this.onsubmit(e) }}
          >
            <Modal.Header closeButton>
              <Modal.Title>{this.titulo}</Modal.Title>
            </Modal.Header>
            <Modal.Body>

              <Form.Group className='mb-3' controlId='alias' as={Col}>
                <Form.Label>Alias</Form.Label>
                <Form.Control autoFocus type='text' onFocus={(e) => { this.onChange(e) }} onChange={(e) => { this.onChange(e) }} placeholder='Alias' defaultValue={(this.state.insert) ? "" : this.props.item.alias} />
              </Form.Group>
              <Row className='mb-3'>
                <Form.Group controlId='nombre' as={Col}>
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='Alias' defaultValue={(this.state.insert) ? "" : this.props.item.nombre} />
                </Form.Group>
                <Form.Group controlId='primerApellido' as={Col}>
                  <Form.Label>Primer Apellido</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='Primer Apellido' defaultValue={(this.state.insert) ? "" : this.props.item.primerApellido} />
                </Form.Group>
                <Form.Group controlId='segundoApellido' as={Col}>
                  <Form.Label>Segundo Apellido</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='Segundo Apellido' defaultValue={(this.state.insert) ? "" : this.props.item.segundoApellido} />
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Form.Group controlId='sexo' as={Col}>
                  <Form.Label>Sexo (Asignado al nacer)</Form.Label>
                  <Form.Select onChange={(e) => { this.onChange(e) }} defaultValue={(this.state.insert) ? "" : this.props.item.sexo} >
                    <option value="masculino">Masculino</option>
                    <option value="femenino">Femenino</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group controlId='orientacionSexual' as={Col}>
                  <Form.Label>Orientación Sexual</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='Orientación Sexual' defaultValue={(this.state.insert) ? "" : this.props.item.orientacionSexual} />
                </Form.Group>
                <Form.Group controlId='identidadGenero' as={Col}>
                  <Form.Label>Identidad de Género</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='Identidad de Género' defaultValue={(this.state.insert) ? "" : this.props.item.identidadGenero} />
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Form.Group controlId='fechaNacimiento' as={Col}>
                  <Form.Label>Fecha de Nacimiento</Form.Label>
                  <Form.Control type='date' onChange={(e) => { this.onChange(e) }} placeholder='CURP' defaultValue={moment((this.state.insert) ? "" : this.props.item.fechaNacimiento).utc().format('YYYY-MM-DD')} />
                </Form.Group>
                <Form.Group controlId='curp' as={Col}>
                  <Form.Label>CURP</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='CURP' defaultValue={(this.state.insert) ? "" : this.props.item.curp} />
                </Form.Group>
                <Form.Group controlId='renavi' as={Col}>
                  <Form.Label>RENAVI</Form.Label>
                  <Form.Control type='text' onChange={(e) => { this.onChange(e) }} placeholder='RENAVI' defaultValue={(this.state.insert) ? "" : this.props.item.renavi} />
                </Form.Group>
              </Row>
              <Row className='mb-3'>
                <Form.Group controlId='estadoCivil' as={Col}>
                  <Form.Label>Estado Civil</Form.Label>
                  <Form.Select onChange={(e) => { this.onChange(e) }} defaultValue={(this.state.insert) ? "" : this.props.item.estadoCivil} >
                    <option value="soltero">Soltero</option>
                    <option value="casado">Casado</option>
                    <option value="divorciado">Divorciado</option>
                    <option value="viudo">Viudo</option>
                  </Form.Select>
                </Form.Group>
                <Form.Group controlId='tipo' as={Col}>
                  <Form.Label>Tipo</Form.Label>
                  <Form.Select onChange={(e) => { this.onChange(e) }} defaultValue={(this.state.insert) ? "" : this.props.item.tipo} >
                    <option value={1}>Ninguno</option>
                    <option value={2}>Víctima</option>
                    <option value={3}>Perpetrador</option>
                    <option value={4}>Victima/Perpetrador</option>
                  </Form.Select>
                </Form.Group>
              </Row>

            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => { this.handleClose() }}>
                Close
              </Button>

              <Button type='submit' variant="primary">
                {(this.state.insert) ? "Guardar" : "Actualizar"}
              </Button>
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }
}

export default ModalPersona